import React from "react";
import PageBannerService from "../../images/poster-service-page.jpeg";
import ServicePageMedia from "../../images/Rapidops-ServicePage.mp4";
import IconDesignSprints from "../../images/icon-design-sprints.svg";
import IconProductStrategy from "../../images/icon-product-strategy.svg";
import IconTechnologyAudits from "../../images/icon-technology-audits.svg";
import IconInnovationCulture1 from "../../images/icon-innovation-culture.svg";

import DigitalExperiencesImage from "../../images/Digital-Experiences.png";
import ImageMobile from "../../images/icon-mobile-digital.svg";
import ImageInnovation from "../../images/icon-innovation.svg";
import ImageWeb from "../../images/icon-web.svg";
import ImageDevops from "../../images/icon-devops.svg";
import IconMobile from "../../icons/icon-mobile-digital.svg";
import IconInnovation from "../../icons/icon-innovation.svg";
import IconWeb from "../../icons/icon-web.svg";
import IconDevops from "../../icons/icon-devops.svg";
import IconIos from "../../icons/icon-iOS-digital.svg";
import IconAndroid from "../../icons/icon-android-digital.svg";
import IconFlutter from "../../icons/icon-flutter-digital.svg";
import IconNode from "../../icons/icon-node-digital.svg";
import IconReact from "../../icons/icon-react-digital.svg";
import IconAngular from "../../icons/icon-angular.svg";
import IconIot from "../../icons/icon-IoT-digital.svg";
import IconWerables from "../../icons/icon-werables.svg";
import IconChatbots from "../../icons/icon-chatbots.svg";
import IconCloud from "../../icons/icon-cloud.svg";
import IconContainers from "../../icons/icon-containers.svg";
import IconAutomation from "../../icons/icon-automation.svg";
import DataAnalyticsImage1 from "../../images/data-analytics-1.svg";
import DataAnalyticsImage2 from "../../images/data-analytics-2.svg";
import DataAnalyticsImage3 from "../../images/data-analytics-3.svg";
import DataAnalyticsImage4 from "../../images/data-analytics-4.svg";

import IconDataVisualizations from "../../icons/icon-data-visualizations.svg";
import IconDataAnalytics from "../../icons/icon-data-analytics-landing.svg";
import IconMachineLearning from "../../icons/icon-machine-learning.svg";
import IconPersonalization from "../../icons/icon-personalization.svg";

import IconAutomateProcesses from "../../icons/icon-automate-processes.svg";
import IconDigitizeProducts from "../../icons/icon-digitize-products.svg";
import IconInnovationCulture from "../../icons/icon-innovation-culture.svg";
import IconModernizeLegacy from "../../icons/icon-modernize-legacy.svg";
import ProductTeamImage from "../../images/product-teams.svg";

import IconExperienceDesign from "../../icons/icon-experience-design.svg";
import IconPrototypeService from "../../icons/icon-prototype-service.svg";
import IconUserResearch from "../../icons/icon-user-research-service.svg";
import IconVisualDesign from "../../icons/icon-visual-design.svg";



export const mainBannerObj = {
  classes: "",
  header: (<>We’re your digital team</>),
  position: "",
  content: (<><p>We turn your ideas into market-leading software products, platforms and solutions.</p></>),
  buttonText: "Get in touch",
  link: "form-section",
  scrollSection: "service-landing-intro",
  mediaType: "video",
  mediaSource: ServicePageMedia,
  mediaClass: "",
  mediaPoster: PageBannerService,
  bottomGap: ""
};


export const gridlayoutstrategyObj = {
  classes: "digital-strategy",
  title: "DISCOVER YOUR OPPORTUNITY",
  header: "Digital Strategy",
  content: (<><p>Validate ideas, evaluate options, and discover the right digital strategy that <br /> solves for both - customer needs and business opportunities.</p></>),
  link: "/services/product-strategy/",
  gridItems: [
    {
      image: IconDesignSprints,
      alt: "design sprints",
      title: "Design Sprints",
      header: "Design Sprints",
      content: "Build concept sprints to unlock new opportuinties by reshaping, defining and modeling new approaches to launch the product."
    },
    {
      image: IconTechnologyAudits,
      alt: "digital product technology",
      title: "Technology Audits",
      header: "Technology Audits",
      content: "Create stable, secure, and highly resilient architecture, engineering, and deployment practices for all digital apps to drive efficiency and elasticity."
    },
    {
      image: IconProductStrategy,
      alt: "digital product development strategy",
      title: "Product Strategy",
      header: "Product Strategy",
      content: "Dramatically improve the time to market and reduce cost with proven MVP strategy and launch your easy-to-use and engaging product with confidence."
    },
    {
      image: IconInnovationCulture1,
      alt: "digital product development strategy",
      title: "Platform Design",
      header: "Platform Design",
      content: "Drive successful transformation and unlock new digital opportunities with powerful vision and strategy from idea to execution."
    },
  ]
};

export const twoColumnImageTextObj = {
  classes: "digital-experiences",
  header: "CREATE WORLD-CLASS EXPERIENCES",
  subHeader: "Digital Experiences",
  intro: <p>Use modern design to solve real problems and create simple products that delight users and fuel business growth.</p>,
  image: DigitalExperiencesImage,
  learnmorelink: "/services/digital-product/",
  listItems: [
    {
      icon: <IconUserResearch />,
      header: "User Research",
      link: "/"
    },
    {
      icon: <IconExperienceDesign />,
      header: "Experience Design",
      link: "/"
    },
    {
      icon: <IconVisualDesign />,
      header: "Visual Design",
      link: "/"
    },
    {
      icon: <IconPrototypeService />,
      header: "Prototyping",
      link: "/"
    },

  ],
};

export const fourcolumnLayoutObj = {
  classes: "digital-engineering",
  header: "develop powerful software",
  subHeader: "Digital Engineering",
  services: [
    {
      image: ImageMobile,
      icon: <IconMobile />,
      alt: "mobile application development",
      title: "Mobile Development",
      header: "Mobile",
      content: "Create seamless brand experiences anywhere and anytime",
      link: "/services/mobile-app-development/",
      technologys: [
        {
          icon: <IconIos />,
          header: "iOS",
        },
        {
          icon: <IconAndroid />,
          header: "Android",
        },
        {
          icon: <IconFlutter />,
          header: "Flutter",
        }
      ],
    }, {
      image: ImageWeb,
      icon: <IconWeb />,
      alt: "web development",
      title: "Web Development",
      header: "Web",
      content: "Launch beautiful, secure and scalable apps, SaaS products, and  platforms",
      link: "/services/web-development/",
      technologys: [
        {
          icon: <IconNode />,
          header: "Node",
        },
        {
          icon: <IconReact />,
          header: "React",
        },
        {
          icon: <IconAngular />,
          header: "Angular",
        }
      ],
    },
    {
      image: ImageInnovation,
      icon: <IconInnovation />,
      alt: "product innovation",
      title: "Innovation",
      header: "Innovation",
      content: "Build a new class of tech that can create disruptive market opportunities",
      link: "/services/digital-transformation/",
      technologys: [
        {
          icon: <IconIot />,
          header: "IoT",
        },
        {
          icon: <IconWerables />,
          header: "Wearable",
        },
        {
          icon: <IconChatbots />,
          header: "Chatbots",
        }
      ],
    }, {
      image: ImageDevops,
      icon: <IconDevops />,
      alt: "DevOps consulting services",
      title: "DevOps Services",
      header: "DevOps",
      content: "Automate infrastructure to reduce cost and accelerate delivery",
      link: "/services/devops-automation/",
      technologys: [
        {
          icon: <IconCloud />,
          header: "Cloud",
        },
        {
          icon: <IconContainers />,
          header: "Containers",
        },
        {
          icon: <IconAutomation />,
          header: "Automation",
        }
      ],
    }
  ]
};

export const twoColumnTextImageObj = {
  classes: "data-analytics",
  header: "deliver actionable intelligence",
  subHeader: "Data Analytics",
  intro: (<><p>Harness the power of data to generate actionable insights and deliver personalized experiences</p></>),
  image1: DataAnalyticsImage1,
  image2: DataAnalyticsImage2,
  image3: DataAnalyticsImage3,
  image4: DataAnalyticsImage4,
  learnmorelink: "/services/data-analytics/",
  listItems: [
    {
      icon: <IconDataVisualizations />,
      header: "Data Visualizations",
      link: "/"
    },
    {
      icon: <IconDataAnalytics />,
      header: "Data Analytics",
      link: "/"
    },
    {
      icon: <IconMachineLearning />,
      header: "Machine Learning",
      link: "/"
    },
    {
      icon: <IconPersonalization />,
      header: "Personalization",
      link: "/"
    },
  ],
};

export const columnLayoutLandingObj = {
  classes: "digital-transform",
  header: "BUILD YOUR DIGITAL FUTURE",
  subHeader: "Digital Transformation",
  services: [
    {
      icon: <IconModernizeLegacy />,
      header: "Modernize Legacy",
      content: "Unlock new opportunities by re-imaging existing legacy systems & interfaces.",
      link: "/"
    },
    {
      icon: <IconDigitizeProducts />,
      header: "Digitize Products",
      content: "Enhance your products & services using advanced digital technology and experiences.",
      link: "/"
    },
    {
      icon: <IconAutomateProcesses />,
      header: "Automate Processes",
      content: "Use tech and data to automate manual work into scalable and cost-effective processes.",
      link: "/"
    },
    {
      icon: <IconInnovationCulture />,
      header: "Innovation Culture",
      content: "Create strategy, processes, tools, team, and culture that fosters innovation - we act as the catalyst.",
      link: "/"
    },

  ]
};


export const twoRowTextImageObj = {
  classes: " ",
  header: "hire our experts",
  subHeader: "Managed Product Teams",
  intro: (<>Need help to hit a critical deadline or to deliver a kick-ass product? We can augment your team with cutting-edge skills at the right time and the right scale.</>),
  image: ProductTeamImage,
  services: [
    {
      header: "Cross-functional Skills",
      content: "Tailored teams that has all skills required to deliver on any project",
    },
    {
      header: "Exceptional Delivery",
      content: "Proven approach, expertise and attitude that never lets you down",
    },
    {
      header: "Flex on-demand",
      content: "Scale up or scale down the team to fit your pace, product, and budget",
    },
  ],
};